// extracted by mini-css-extract-plugin
export default {"wrap":"InfoMessage_wrap__7DZ2W","message":"InfoMessage_message__l1r5g","missing-fields":"InfoMessage_missing-fields__lpW8M","field":"InfoMessage_field__ilzu5"};